// src/components/ProgramsColumn.jsx
import React from "react";

const ProgramsColumn = () => {
  const programs = [
    "महाराष्ट्र राज्य ग्रामीण जीवनोती अभियान",
    "राष्ट्रीय ग्राम स्वराज अभियान",
    "राज्य व्यवस्थापन युनिट – ग्रामीण गृहनिर्माण"
  ];

  return (
    <div className="bg-custom-gray p-4 border rounded shadow-sm">
      <h2 className="font-bold text-lg border-b pb-2 mb-2 text-orange-600">प्रमुख कार्यक्रम</h2>
      <ul className="list-disc pl-5 space-y-2 text-gray-700">
        {programs.map((prog, idx) => (
          <li key={idx}>{prog}</li>
        ))}
      </ul>
    </div>
  );
};

export default ProgramsColumn;
